export const MODEL_STACK_IDS = [
  'openai_5_nano_54mini',
  'claude_haiku_sonnet',
  'openai_5_nano_5',
  'openai_5_mini_5',
] as const

export type ModelStackId = (typeof MODEL_STACK_IDS)[number]

export interface ModelStackOption {
  id: ModelStackId
  label: string
  description: string
  role: 'production' | 'lab'
}

export const MODEL_STACK_OPTIONS: ModelStackOption[] = [
  {
    id: 'openai_5_nano_54mini',
    label: 'GPT-5-nano + GPT-5.4-mini (production)',
    description: 'Cheap: GPT-5-nano · Quality: GPT-5.4-mini — launch default',
    role: 'production',
  },
  {
    id: 'claude_haiku_sonnet',
    label: 'Claude Haiku + Sonnet (lab)',
    description: 'Cheap tier: Haiku 4.5 · Quality: Sonnet 4.6 — quality baseline',
    role: 'lab',
  },
  {
    id: 'openai_5_nano_5',
    label: 'GPT-5-nano + GPT-5 (lab)',
    description: 'Cheap: GPT-5-nano · Quality: GPT-5 — Lab A',
    role: 'lab',
  },
  {
    id: 'openai_5_mini_5',
    label: 'GPT-5-mini + GPT-5 (lab)',
    description: 'Cheap: GPT-5-mini · Quality: GPT-5 — Lab B',
    role: 'lab',
  },
]

export const DEFAULT_MODEL_STACK: ModelStackId = 'openai_5_nano_54mini'

export function isModelStackId(value: string): value is ModelStackId {
  return (MODEL_STACK_IDS as readonly string[]).includes(value)
}

export function modelStackLabel(id: ModelStackId): string {
  return MODEL_STACK_OPTIONS.find((o) => o.id === id)?.label ?? id
}
